(function () {
    "use strict";

    if (!window.__lvIsAllowedPdp || !window.__lvIsAllowedPdp()) return;

    var FORM_SEL = 'form[action="/cart/add"], form[action="/cart/add/"], form[action*="/cart/add"]';
    var PLAN_INPUT_SEL = '[name="selling_plan"], [name="selling_plan_id"], input[name*="selling"][name*="plan"]';
    var LOOP_OPTION_SEL = '.loop-widget-purchase-option';
    var LOOP_SELECTED_CLASS = 'loop-widget-purchase-option-selected';
    var LOOP_HEADER_SEL = '.loop-widget-purchase-option-header';
    var PLAN_ANY_IN_OPT = '[data-selling-plan-id], [data-plan], [data-plan-id]';

    var raf = 0;
    var formRef = null;

    function $(sel, root) {
        return (root || document).querySelector(sel);
    }

    function $$(sel, root) {
        return Array.prototype.slice.call((root || document).querySelectorAll(sel));
    }

    function schedule(fn) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
        raf = 0;
        fn();
        });
    }

    function isAffiliateMode() {
        return !!(
        window.__lvIsAffiliatePricingActive &&
        window.__lvIsAffiliatePricingActive()
        );
    }

    function isSelectedOption(opt) {
        if (!opt) return false;
        if (opt.classList.contains(LOOP_SELECTED_CLASS)) return true;
        if (opt.getAttribute('aria-checked') === 'true') return true;
        var h = $(LOOP_HEADER_SEL, opt);
        return !!h && (
        h.getAttribute('aria-selected') === 'true' ||
        h.getAttribute('aria-checked') === 'true'
        );
    }

    function getForm() {
        return formRef || $(FORM_SEL);
    }

    function getHiddenPlanInput(form) {
        return form ? form.querySelector(PLAN_INPUT_SEL) : null;
    }

    function getPlanIdFromSelectedLoopOption() {
        var selectedOpt = $$(LOOP_OPTION_SEL).find(isSelectedOption);
        if (!selectedOpt) return null;
        var nodeWithPlan = selectedOpt.matches(PLAN_ANY_IN_OPT)
        ? selectedOpt
        : $(PLAN_ANY_IN_OPT, selectedOpt);
        if (!nodeWithPlan) return null;
        return (
        nodeWithPlan.dataset.sellingPlanId ||
        nodeWithPlan.dataset.plan ||
        nodeWithPlan.dataset.planId ||
        ''
        ).trim() || null;
    }

    function getCurrentPlanId(form) {
        var hidden = getHiddenPlanInput(form);
        if (hidden && hidden.value) return hidden.value.trim();
        return getPlanIdFromSelectedLoopOption();
    }

    function setHiddenPlanValue(form, planId) {
        var hidden = getHiddenPlanInput(form);
        if (!hidden || !planId) return false;

        var next = String(planId).trim();
        var prev = (hidden.value || '').trim();
        if (!next || prev === next) return false;

        hidden.value = next;
        hidden.setAttribute('value', next);

        hidden.dispatchEvent(new Event('input', { bubbles: true }));
        hidden.dispatchEvent(new Event('change', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('sellingplan:change', {
        detail: { planId: next, previousPlanId: prev, source: 'lv_affiliate_swap' }
        }));

        return true;
    }

    function syncPlanToPricingMode() {
        var form = getForm();
        if (!form) return;

        var currentPlanId = getCurrentPlanId(form);
        if (!currentPlanId) return; // one-time purchase or widget not ready yet

        var mappedPlanId = currentPlanId;

        if (isAffiliateMode()) {
        if (window.__lvMapSellingPlanId) {
            mappedPlanId = window.__lvMapSellingPlanId(currentPlanId, 'to_affiliate');
        }
        } else {
        if (window.__lvMapSellingPlanId) {
            mappedPlanId = window.__lvMapSellingPlanId(currentPlanId, 'to_standard');
        }
        }

        if (!mappedPlanId || String(mappedPlanId) === String(currentPlanId)) return;

        var changed = setHiddenPlanValue(form, mappedPlanId);
        if (changed) {
        console.log('[LV] selling_plan synced to pricing mode', {
            affiliateMode: isAffiliateMode(),
            from: String(currentPlanId),
            to: String(mappedPlanId)
        });
        }
    }

    function wire() {
        formRef = $(FORM_SEL);
        if (!formRef) return;

        schedule(syncPlanToPricingMode);
        setTimeout(syncPlanToPricingMode, 50);
        setTimeout(syncPlanToPricingMode, 250);
        setTimeout(syncPlanToPricingMode, 800);

        if ('MutationObserver' in window) {
        var mo = new MutationObserver(function (muts) {
            var shouldRun = false;

            for (var i = 0; i < muts.length; i++) {
            var m = muts[i];

            if (m.type === 'childList') {
                var added = Array.prototype.slice.call(m.addedNodes || []);
                if (added.some(function (n) {
                return n && n.nodeType === 1 && (
                    (n.matches && (n.matches(PLAN_INPUT_SEL) || n.matches(LOOP_OPTION_SEL))) ||
                    (n.querySelector && (n.querySelector(PLAN_INPUT_SEL) || n.querySelector(LOOP_OPTION_SEL)))
                );
                })) {
                shouldRun = true;
                break;
                }
            }

            if (m.type === 'attributes') {
                var t = m.target;
                if (
                t &&
                t.nodeType === 1 &&
                (
                    (t.matches && t.matches(PLAN_INPUT_SEL)) ||
                    (t.matches && t.matches(LOOP_OPTION_SEL)) ||
                    (t.closest && t.closest(LOOP_OPTION_SEL))
                )
                ) {
                shouldRun = true;
                break;
                }
            }
            }

            if (shouldRun) schedule(syncPlanToPricingMode);
        });

        mo.observe(formRef, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['value', 'class', 'aria-checked', 'aria-selected']
        });

        formRef._lvAffiliatePlanSyncMo = mo;
        }
    }

    document.addEventListener('change', function (e) {
        var t = e.target;
        if (!(t instanceof Element)) return;
        if (
        t.matches(PLAN_INPUT_SEL) ||
        t.matches(LOOP_OPTION_SEL) ||
        t.closest(LOOP_OPTION_SEL)
        ) {
        schedule(syncPlanToPricingMode);
        }
    }, true);

    document.addEventListener('click', function (e) {
        var t = e.target;
        if (!(t instanceof Element)) return;
        if (t.closest(LOOP_OPTION_SEL)) {
        schedule(syncPlanToPricingMode);
        }
    }, true);

    window.addEventListener('lv:affiliate_pricing_activated', function () {
        schedule(syncPlanToPricingMode);
        setTimeout(syncPlanToPricingMode, 50);
        setTimeout(syncPlanToPricingMode, 250);
    });

    window.addEventListener('pageshow', function () {
        schedule(syncPlanToPricingMode);
    });

    if ('MutationObserver' in window) {
        var rootObserver = new MutationObserver(function () {
        var current = $(FORM_SEL);
        if (current !== formRef) {
            if (formRef && formRef._lvAffiliatePlanSyncMo) {
            try { formRef._lvAffiliatePlanSyncMo.disconnect(); } catch (e) {}
            }
            formRef = current || null;
            if (formRef) wire();
        }
        });

        rootObserver.observe(document.documentElement, {
        childList: true,
        subtree: true
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', wire, { once: true });
    } else {
        wire();
    }
 })();